<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate
      :openDialog="isOpen"
      :widthDialog="'900px'"
      :classDialog="'create-dialog job-create'"
      :offsetTop="'3vh'"
      @closeDialog="$emit('closeDialog')"
      @closed="$emit('dialogClosed')"
      :appendToBody="true"
      :modalAppendToBody="true"
    >
      <template #body>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-position="left"
          label-width="97px"
        >
          <el-form-item prop="taskTitle" class="input-no__label">
            <el-input
              v-model="form.taskTitle"
              size="large"
              v-focus
              class="noPaddingLeft style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
              placeholder="Nhập tên công việc (*)"
              prop="name"
              maxlength="250"
            />
          </el-form-item>

          <el-row :gutter="12" class="margin-bottom-5">
            <el-col :span="8">
              <el-form-item
                class="custom-label__form input-no__label"
                prop="priority"
              >
                <label class="label">Độ ưu tiên &nbsp;</label>
                <multiselect
                  :class="[
                    form.priority ? '' : '',
                    'txt-center',
                    'style-fullWidth'
                  ]"
                  :options="priorities"
                  label="fullName"
                  track-by="id"
                  :preselect-first="true"
                  v-model="form.priority"
                  :custom-label="customLabelPriority"
                  placeholder="-"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :searchable="true"
                  open-direction="bottom"
                >
                  <template slot="noResult"
                  >Không tìm thấy dữ liệu phù hợp.
                  </template>
                  <template slot="noOptions"
                  >Danh sách trống
                  </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <el-tag
                      size="mini"
                      :class="[
                        'priority',
                        getPriorityClass(option.categoryName),
                        'txt-center'
                      ]"
                    >{{ option.categoryName }}
                    </el-tag>
                  </template>
                </multiselect>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="custom-label__form  input-no__label margin-left-10"
                prop="startDate"
              >
                <label class="label">Ngày bắt đầu </label>&nbsp;&nbsp;&nbsp;
                <el-date-picker
                  size="mini"
                  class="select_dateTime input-none__border"
                  v-model="startDate"
                  placeholder="dd/mm/yyyy"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                class="custom-label__form  input-no__label margin-left-10"
                prop="deadline"
              >
                <label class="label field-needed">Hạn hoàn thành</label>
                <el-date-picker
                  size="mini"
                  class="select_dateTime input-none__border"
                  v-model="deadline"
                  placeholder="dd/mm/yyyy"
                  type="date"
                  format="dd/MM/yyyy"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!--  -->
          <el-row :gutter="24" class="margin-bottom-5" v-if="showDelegateRow">
            <el-col :span="8">
              <el-form-item label="Công việc" prop="checkTaskDelegate">
                <el-checkbox
                  :border="false"
                  v-model="form.checkTaskDelegate"
                  @change="checkDelegator"
                  class="style-fullWidth"
                >
                  Được ủy quyền
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                v-if="showListDelegator"
                class="custom-label__form input-no__label flex-row flex__left"
                prop="delegator"
              >
                <label class="label field-needed">Người ủy quyền</label
                >&nbsp;&nbsp;
                <multiselect
                  :class="[form.delegator ? '' : '', 'style-fullWidth']"
                  :options="listDelegator"
                  label="fullName"
                  track-by="id"
                  :preselect-first="true"
                  v-model="form.delegator"
                  :custom-label="customLabelSelectPeople"
                  placeholder="Gõ tên để bắt đầu tìm kiếm"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :searchable="true"
                  :internal-search="true"
                  open-direction="bottom"
                  @input="changeDelegator"
                >
                  <template slot="noResult"
                  >Không tìm thấy dữ liệu phù hợp.
                  </template>
                  <template slot="noOptions"
                  >Danh sách trống
                  </template>
                  <template slot="singleLabel" slot-scope="{ option }">
                    <div class="selected-people flex-row flex__left">
                      <div class="img">
                        <div
                          class="avatar_fake flex-row flex__center margin-right-10"
                        >
                          {{ option.fullName | buildShortNameFilter }}
                        </div>
                      </div>
                      <p class="text padding-right-10">{{ option.fullName }}</p>
                    </div>
                  </template>
                </multiselect>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- -->
          <el-row :gutter="24" class="margin-bottom-5">
            <el-col :span="15" v-if="taskType !== TASK_TYPE_DANGKI">
              <el-form-item
                class="custom-label__form input-no__label flex-row flex__left"
                prop="receiverUserDeptRole"
              >
                <label class="label field-needed">Người thực hiện</label
                >&nbsp;&nbsp;
                <el-select
                  filterable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.receiverUserDeptRole"
                  placeholder="-"
                  clearable
                  value-key="id"
                >
                  <el-option
                    v-for="item in receivers"
                    :key="item.id"
                    :value="item"
                    :label="receiverHandlerLabel(item)"
                  >

                    <div
                      class="flex-row flex__left padding-right-10 inline-block"
                    >
                        <span class="font-size__medium">{{
                            item.fullName
                          }}</span>
                      <span class="font-size__small"
                      >({{
                          item.positionName +
                          " - " +
                          item.deptName
                        }})</span>
                      <span style="position: relative;top:-10px;left: 0px;">
                           <el-tooltip
                             v-if="item.absentCount&&item.absentCount!=0"
                             :content="tooltipContent(item)"
                             placement="right"
                             effect="dark">
                           <absent-notify ></absent-notify>
                         </el-tooltip>
                      </span>
                    </div>
                  </el-option>
                </el-select>
<!--                <multiselect-->
<!--                  :class="[-->
<!--                    form.receiverUserDeptRole ? '' : '',-->
<!--                    'style-fullWidth'-->
<!--                  ]"-->
<!--                  :options="receivers"-->
<!--                  label="fullName"-->
<!--                  track-by="id"-->
<!--                  :preselect-first="true"-->
<!--                  v-model="form.receiverUserDeptRole"-->
<!--                  :custom-label="customLabelSelectPeople"-->
<!--                  placeholder="Gõ tên để bắt đầu tìm kiếm"-->
<!--                  :multiple="false"-->
<!--                  :close-on-select="true"-->
<!--                  :clear-on-select="true"-->
<!--                  :searchable="true"-->
<!--                  :internal-search="true"-->
<!--                  open-direction="bottom"-->
<!--                >-->
<!--                  <template slot="noResult"-->
<!--                  >Không tìm thấy dữ liệu phù hợp.-->
<!--                  </template>-->
<!--                  <template slot="noOptions"-->
<!--                  >Danh sách trống-->
<!--                  </template>-->
<!--                  <template slot="singleLabel" slot-scope="{ option }">-->
<!--                    <div class="selected-people flex-row flex__left">-->
<!--                      <div class="img">-->
<!--                        <div-->
<!--                          class="avatar_fake flex-row flex__center margin-right-10"-->
<!--                        >-->
<!--                          {{ option.fullName | buildShortNameFilter }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <p class="text padding-right-10">{{ option.fullName }}</p>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </multiselect>-->
              </el-form-item>
            </el-col>
            <el-col :span="15" v-if="taskType !== TASK_TYPE_GIAOVIEC">
              <el-form-item label="Người giao " prop="assignerUserDeptRole">

                <el-select
                  filterable
                  class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                  v-model="form.assignerUserDeptRole"
                  placeholder="-"
                  clearable
                  value-key="id"
                >
                  <el-option
                    v-for="item in assigners"
                    :key="item.id"
                    :value="item"
                    :label="receiverHandlerLabel(item)"
                  >

                    <div
                      class="flex-row flex__left padding-right-10 inline-block"
                    >
                        <span class="font-size__medium">{{
                            item.fullName
                          }}</span>
                      <span class="font-size__small"
                      >({{
                          item.positionName +
                          " - " +
                          item.deptName
                        }})</span>
                      <span style="position: relative;top:-10px;left: 0px;">
                           <el-tooltip
                             v-if="item.absentCount&&item.absentCount!=0"
                             :content="tooltipContent(item)"
                             placement="right"
                             effect="dark">
                           <absent-notify ></absent-notify>
                         </el-tooltip>
                      </span>
                    </div>
                  </el-option>
                </el-select>
<!--                <multiselect-->
<!--                  :class="[-->
<!--                    form.assignerUserDeptRole ? '' : '',-->
<!--                    'style-fullWidth'-->
<!--                  ]"-->
<!--                  :options="assigners"-->
<!--                  label="fullName"-->
<!--                  track-by="id"-->
<!--                  :preselect-first="true"-->
<!--                  v-model="form.assignerUserDeptRole"-->
<!--                  :custom-label="customLabelSelectPeople"-->
<!--                  placeholder="Gõ tên để bắt đầu tìm kiếm"-->
<!--                  :multiple="false"-->
<!--                  :close-on-select="true"-->
<!--                  :clear-on-select="true"-->
<!--                  :searchable="true"-->
<!--                  :internal-search="true"-->
<!--                  open-direction="bottom"-->
<!--                  @input="assignerUserDeptRoleChange"-->
<!--                >-->
<!--                  <template slot="noResult"-->
<!--                  >Không tìm thấy dữ liệu phù hợp.-->
<!--                  </template>-->
<!--                  <template slot="noOptions"-->
<!--                  >Danh sách trống-->
<!--                  </template>-->
<!--                  <template slot="singleLabel" slot-scope="{ option }">-->
<!--                    <div class="selected-people flex-row flex__left">-->
<!--                      <div class="img">-->
<!--                        <div-->
<!--                          class="avatar_fake flex-row flex__center margin-right-10"-->
<!--                        >-->
<!--                          {{ option.fullName | buildShortNameFilter }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <p class="text padding-right-10">{{ option.fullName }}</p>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </multiselect>-->
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item
                class="margin-left-10 custom-label__form noPaddingLeft input-no__label"
                prop="manday"
              >
                <label class="label">Nhân công (ngày)&nbsp;</label>
                <el-input-number
                  size="mini"
                  v-model="form.manday"
                  :min="0.5"
                  class="style-fullWidth noPaddingLeft"
                  :precision="1"
                  :step="0.5"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12" class="margin-bottom-5 margin-top-5">
            <el-col :span="12">
              <el-form-item
                class="custom-label__form input-no__label flex-row flex__left"
              >
                <label class="label">Người phối hợp </label>
                <div class="flex-row flex__left" style="margin-left: 5px">
                  <el-popover trigger="hover" placement="top" width="500">
                    <el-table
                      :data="coordinators"
                      style="width: 100%"
                      size="mini"
                      :show-header="false"
                      max-height="300"
                      stripe
                    >
                      <el-table-column width="50">
                        <template slot-scope="scope">
                          <div
                            class="avatar_fake flex-row flex__center margin-right-10"
                          >
                            {{ scope.row.fullName | buildShortNameFilter }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column show-overflow-tooltip>
                        <template slot-scope="scope">
                          <span
                          >{{ scope.row.fullName }} ({{
                              scope.row.positionName
                            }}
                            - {{ scope.row.deptName }})</span
                          >
                        </template>
                      </el-table-column>
                      <el-table-column width="60" align="left">
                        <template slot-scope="scope">
                          <i
                            class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red clickable"
                            @click="removeCoordinator(scope.row)"
                          ></i>
                        </template>
                      </el-table-column>
                    </el-table>

                    <div slot="reference" class="list-people margin-right-10">
                      <div
                        v-for="coordinator in (coordinators || []).slice(0, 3)"
                        :key="coordinator.id"
                        class="item"
                      >
                        <div v-if="coordinator.url" class="avatar_bg"></div>
                        <div v-else class="avatar_fake flex-row flex__center">
                          {{ coordinator.fullName | buildShortNameFilter }}
                        </div>
                      </div>
                      <div
                        v-show="coordinators && coordinators.length > 3"
                        class="item avatar_fake flex-row flex__center"
                      >
                        +{{ coordinators.length - 3 }}
                      </div>
                    </div>
                  </el-popover>
                  <el-button
                    size="mini"
                    class="addDocs flex-row flex__center btn-none__border color__black"
                    @click="isOpenAddCoordinatorsDialog = true"
                  >
                    <span class="flex-row flex__center">
                      <i
                        class="fas fa-user-plus font-size__small color__cyan"
                      ></i>
                      &nbsp;Thêm
                    </span>
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="Mô tả "
            class="description-job margin-bottom-5"
            prop="taskDetail"
          >
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.taskDetail"
              prop="taskDetail"
              maxlength="2000"
            ></el-input>
          </el-form-item>

          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item class="content width__100">
                <div class="jobInfoAttachment">
                  <div
                    v-for="(vbAttachment, vbAttachmentIndex) in vbAttachments"
                    v-bind:key="vbAttachment.id"
                    class="file-uploaded input-none__border"
                  >
                    <div
                      class="file clickable flex-row flex__between padding-0"
                    >
                      <a
                        class="flex-row flex__left margin-left-10"
                        v-openInNewTab
                        :href="
                          getToken(vbAttachment.id)
                            | buildAttachmentURL({
                              type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                            })
                        "
                      >
                        <fileTypeImage
                          :fileExtention="vbAttachment.fileExtention"
                          :customClass="''"
                        />
                        <span class="">{{ vbAttachment.fileName }}</span>
                      </a>
                      <i
                        class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red"
                        @click="removeAttachment(vbAttachmentIndex)"
                      ></i>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                label="File đính kèm"
                class="has-border__bottom padding-bottom-10"
              >
                <el-upload
                  class="upload-demo style-fullWidth inputLog"
                  drag
                  :action="uploadAttachmentURL"
                  size="mini"
                  :on-success="
                    response =>
                      onUploadSuccess(response).then(response =>
                        uploadAttachmentSuccess(response)
                      )
                  "
                  :data="uploadAttachmentAdditionalData()"
                  :file-list="attachmentFiles"
                  :show-file-list="false"
                  :headers="uploadAttachmentHeaders"
                  :before-upload="
                    file => validateUploadFile(file, { acceptFileTypes: ['*'] })
                  "
                  :on-error="onUploadError"
                  v-loading="isUploading"
                >
                  <div class="el-upload__text mb-10">
                    <p class="margin-0 padding-0">Tải tệp đính kèm</p>
                    <img
                      class="icon-small"
                      src="@/assets/img/new-symbol/upload-cloud.svg"
                      alt
                    />
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="12" type="flex" class="listAttachments item">
            <el-col :span="24" class="has-border__bottom">
              <el-form>
                <el-form-item
                  class="style-fullWidth padding-bottom-10"
                  label="Văn bản liên quan"
                >
                  <template>
                    <el-table
                      class="table"
                      style="width: 100%; margin-bottom:12px;"
                      size="mini"
                      max-width="300"
                      :data="docRelations"
                    >
                      <el-table-column
                        label="Trích yếu"
                        property="quote"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope">
                          <div class="clickable">
                            <a
                              class="flex-row flex__left margin-left-10"
                              @click="downloadDoc(scope.row)"
                            >
                              <span>
                                <file-type-image
                                  :custom-class="
                                    'icon-small margin-right-10 clickable'
                                  "
                                >
                                </file-type-image>
                              </span>
                              {{ scope.row.quote || "-" }}
                            </a>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Số ký hiệu"
                        align="left"
                        header-align="left"
                        width="150"
                        property="docCode"
                        show-overflow-tooltip
                      ></el-table-column>
                      <el-table-column
                        label="Ngày văn bản"
                        align="left"
                        header-align="left"
                        width="150"
                        property="docDate"
                        show-overflow-tooltip
                      >
                        <template slot-scope="scope"
                        >{{
                          scope.row.docDate
                          | dateFormatter({ dateFormat: "DD/MM/YYYY" })
                          }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        header-align="left"
                        align="left"
                        width="60"
                      >
                        <template slot-scope="scope">
                          <i
                            class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red clickable"
                            @click="removeDocRelation(scope.row)"
                          ></i>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                  <el-button
                    size="mini"
                    type="primary"
                    class="addDocs color__white flex-row flex__center margin-bottom-10 btn-none__border"
                    @click="isOpenAddDocDialog = true"
                  >
                    Thêm văn bản
                    <i class="el-icon-circle-plus font-size__small"></i>
                  </el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-form>
      </template>

      <template #footer>
        <div class="flex-row flex__left form-button__action margin-top-10">
          <el-button
            type="success"
            size="mini"
            class="addDocs btn-none__border  color__white bg__blue"
            @click="save"
            :disabled="isProcessing"
          >
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isProcessing
                    ? 'fas fa-save font-size__small'
                    : 'el-icon-loading'
                ]"
              ></i>
              &nbsp;&nbsp;
              {{ viewType === "assigner" ? "Giao việc" : "Đăng ký" }}
            </span>
          </el-button>
          <el-button
            type="info"
            size="mini"
            class="btn__cancel btn-none__border"
            @click="cancel"
          >
            <span class="flex-row flex__center">
              <i class="far fa-times-circle font-size__small"></i>
              &nbsp;&nbsp;Hủy
            </span>
          </el-button>
        </div>
      </template>
    </dialogTemplate>

    <dialog-add-people
      :isOpen="isOpenAddCoordinatorsDialog"
      :addedPeopleIds="coordinatorIds"
      :viewType="viewType"
      :delegatorId="form.delegator ? form.delegator.id : null"
      v-if="isEnableAddCoordinatorsDialog"
      @closed="isEnableAddCoordinatorsDialog = false"
      @closeDialog="closeAddCoordinatorsDialog"
      @submit="addCoordinators"
    />

    <dialog-add-docs
      :isOpen="isOpenAddDocDialog"
      :docIds="docIds"
      v-if="isEnableAddDocDialog"
      @closed="isEnableAddDocDialog = false"
      @closeDialog="closeAddDocDialog"
      @submit="addDocRelations"
    />
  </div>
</template>

<script>
  import categoryViewService from "../../../services/categoryViewService";
  import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
  import constants from "../../../constants";
  import buildShortNameFilter from "../../../filters/buildShortNameFilter";
  import buildAttachmentURL from "../../../filters/buildAttachmentURL";
  import h from "../../../services/h";
  import utils from "../../../services/utils";
  import dateFormatter from "../../../filters/dateFormatter";
  import tkTaskService from "../../../services/tkTaskService";
  import FileTypeImage from "../FileTypeImage";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
  import vbIncomingDocUserViewService from "../../../services/vbIncomingDocUserViewService";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbOutgoingDocUserViewService from "../../../services/vbOutgoingDocUserViewService";
  import downloadService from "../../../services/downloadService";
  import dateUtils from "../../../dateUtils";
  import categoryService from "../../../services/categoryService";
  import attachmentService from "../../../services/attachmentService";
  import tkTaskDocRelationService from "../../../services/tkTaskDocRelationService";
  import tkTaskAssignViewService from "../../../services/tkTaskAssignViewService";
  import DialogAddPeople from "./dialog-add-people";
  import AbsentNotify from "../../common/absents/absent-notify";
  // import vbDelegateInfoService from "../../../services/vbDelegateInfoService";

  export default {
    name: "create-job-dialog",
    mixins: [uploadFileMixin, vbAttachmentTokenMixin, handleRequestErrorMixin],
    props: [
      "isOpen",
      "taskType",
      "parentTaskId",
      "viewType",
      "docId",
      "docType",
      "copyFromTaskId",
      "forwardTaskId"
    ],
    filters: {buildShortNameFilter, dateFormatter, buildAttachmentURL},
    components: {
      AbsentNotify,
      DialogAddPeople,
      FileTypeImage,
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      Multiselect: () => import("vue-multiselect"),
      dialogAddDocs: () => import("./dialog-add-docs.vue")
    },
    data() {
      return {
        docIds: [],
        DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
        TASK_TYPE_DANGKI: constants.TASK_TASK_TYPE.DANGKI,
        TASK_TYPE_GIAOVIEC: constants.TASK_TASK_TYPE.GIAOVIEC,

        priorities: [],
        deadline: null,
        startDate: null,
        attachmentFiles: [],
        vbAttachments: [],
        receivers: [],
        listDelegator: [],
        assigners: [],
        coordinators: [],
        docRelations: [],
        coordinatorIds: [],

        isOpenAddCoordinatorsDialog: false,
        isEnableAddCoordinatorsDialog: false,
        isOpenAddDocDialog: false,
        isEnableAddDocDialog: false,
        isProcessing: false,
        showListDelegator: false,
        showDelegateRow: false,

        form: {
          taskTitle: null,
          taskDetail: null,
          deadline: null,
          startDate: null,
          parentId: null,
          manday: null,
          priority: null,
          delegator: null,
          checkTaskDelegate: null,
          receiverUserDeptRole: null,
          assignerUserDeptRole: null
        },
        coordinatorsParentTask: [],
        docRelationForms: [],
        attachmentIds: [],
        rules: {
          // priority: [
          //   {required: true, message: "Trường dữ liệu bắt buộc", trigger: "blur"}
          // ],
          taskTitle: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          taskDetail: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          deadline: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          manday: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          receiverUserDeptRole: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          assignerUserDeptRole: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ],
          delegator: [
            {
              required: true,
              message: "Trường dữ liệu bắt buộc",
              trigger: "blur"
            }
          ]
        }
      };
    },

    watch: {
      coordinators(newValue) {
        this.coordinatorIds = h.collect(newValue, item => item.id);
      },
      deadline(newValue) {
        this.form.deadline = newValue ? newValue.getTime() : null;
      },
      startDate(newValue) {
        this.form.startDate = newValue ? newValue.getTime() : null;
      },
      isOpenAddDocDialog(newValue) {
        newValue && (this.isEnableAddDocDialog = newValue);
      },
      isOpenAddCoordinatorsDialog(newValue) {
        newValue && (this.isEnableAddCoordinatorsDialog = newValue);
      }
    },

    computed: {
      deptId() {
        return this.$store.getters.userDeptRole.deptId;
      },
      userDeptRole() {
        return this.$store.getters.userDeptRole;
      }
    },

    created() {
      this.loadCategories();
      (!this.copyFromTaskId && !this.forwardTaskId
          ? Promise.resolve()
          : this.copyFromTaskId
            ? this.initCopyFromTask()
            : this.initForwardTaskId()
      ).then(() => this.initForm());
      this.taskType !== this.TASK_TYPE_GIAOVIEC && this.loadAssigners();
      this.taskType !== this.TASK_TYPE_DANGKI &&
      this.loadAllDelegatorByCurrentUser();
      this.taskType !== this.TASK_TYPE_DANGKI && this.loadReceivers();
      this.initGiaoViecNhanh();
    },

    methods: {
      tooltipContent(item){
        return `Vắng mặt từ `+dateFormatter(item.absentStartTime)+` đến `+dateFormatter(item.absentDeadlineTime);
      },
      receiverHandlerLabel(option) {
        let usersView = option;

        return `${usersView.fullName} (${usersView.positionName} - ${
          usersView.deptName
        })`;
      },

      initCopyFromTask() {
        return tkTaskService
          .findById(this.copyFromTaskId)
          .then(response => response.data)
          .then(copyTkTask =>
            Promise.all([
              this.initForCopyTask_(copyTkTask),
              this.cloneCoordinator(copyTkTask)
            ])
          );
      },

      initForwardTaskId() {
        return tkTaskService
          .findById(this.forwardTaskId)
          .then(response => response.data)
          .then(copyTkTask => this.initForCopyTask_(copyTkTask));
      },

      checkDelegator() {
        if (this.form.checkTaskDelegate) {
          this.showListDelegator = true;
        } else {
          this.showListDelegator = false;
        }
      },

      changeDelegator(event) {
        this.loadReceivers();
      },

      initForCopyTask_(copyTkTask) {
        this.form.taskTitle = `(Copy) ${copyTkTask.taskTitle}`;
        this.form.taskDetail = copyTkTask.taskDetail;
        this.form.manday = copyTkTask.manday;
        this.deadline = dateUtils.toMoment(copyTkTask.deadline).toDate();
        this.startDate = copyTkTask.startDate
          ? dateUtils.toMoment(copyTkTask.startDate).toDate()
          : null;

        return Promise.all([
          (copyTkTask.priority
              ? categoryService
                .findById(copyTkTask.priority)
                .then(response => response.data)
              : Promise.resolve(copyTkTask)
          ).then(priority => (this.form.priority = priority)),
          this.cloneAttachments(copyTkTask),
          this.cloneDocRelations(copyTkTask)
        ]);
      },

      cloneCoordinator(copyTkTask) {
        return tkTaskAssignViewService
          .findAll({taskId: copyTkTask.id})
          .then(response => {
            let coordinators = h.findAll(
              response.data,
              item =>
                item.processType !== constants.TASK_ASSIGN_PROCESS_TYPE.XULICHINH
            );
            return h.collect(
              coordinators,
              coordinator => coordinator.receiverUserDeptRoleId
            );
          })
          .then(userDeptRoleIds => {
            return userDeptRoleIds && userDeptRoleIds.length
              ? userDeptRoleViewService
                .findAllByIdIn(userDeptRoleIds)
                .then(response => response.data)
              : Promise.resolve([]);
          })
          .then(
            userDeptRoleViews =>
              userDeptRoleViews && this.coordinators.push(...userDeptRoleViews)
          );
      },

      cloneAttachments(copyTkTask) {
        return attachmentService
          .cloneFromTask(copyTkTask.id)
          .then(response => (this.vbAttachments = response.data || []));
      },

      cloneDocRelations(copyTkTask) {
        return tkTaskDocRelationService.findAll({taskId: copyTkTask.id}).then(
          response =>
            (this.docRelations = h.collect(response.data, docRelation_ => {
              this.docIds.push(docRelation_.docId);
              return {
                docId: docRelation_.docId,
                docType: docRelation_.docType,
                quote: docRelation_.quote,
                docCode: docRelation_.docCode,
                docDate: docRelation_.docDate
              };
            }))
        );
      },

      downloadDoc(taskDocRelation) {
        switch (taskDocRelation.docType) {
          case constants.TASK_DOC_RELATION.VB_DI:
            return downloadService.downloadReferenceOutgoingDoc(
              taskDocRelation.docId
            );
          case constants.TASK_DOC_RELATION.VB_DEN:
            return downloadService.downloadFileIncomingDoc(taskDocRelation.docId);
          default:
            break;
        }
      },

      // trong TH giao viec nhanh tu man hinh chi tiet van ban
      initGiaoViecNhanh() {
        if (!this.docId) return;
        if (this.docType === constants.DOC_TYPE.VB_DEN) {
          vbIncomingDocUserViewService.findByDocId(this.docId).then(response => {
            let docs = response.data;
            let doc = docs && docs.length ? docs[0] : null;
            if (doc) {
              this.docRelations.push({
                docId: doc.vbIncomingDocUserViewKey.id,
                docType: constants.TASK_DOC_RELATION.VB_DEN,
                quote: doc.quote,
                docCode: doc.docCode,
                docDate: doc.docDate
              });
            }
          });
        } else {
          vbOutgoingDocUserViewService.findByDocId(this.docId).then(response => {
            let docs = response.data;
            let doc = docs && docs.length ? docs[0] : null;
            if (doc) {
              this.docRelations.push({
                docId: doc.docId,
                docType: constants.TASK_DOC_RELATION.VB_DI,
                quote: doc.quote,
                docCode: doc.docCode,
                docDate: doc.docDate
              });
            }
          });
        }
      },

      assignerUserDeptRoleChange() {
        this.$refs.form.validateField("assignerUserDeptRole");
      },

      // /**
      //  * trong TH tạo task con thì người thực hiện chỉ có thể là nằm trong danh sách người phối hợp;
      //  **/
      // initReceiversForCreateChildTask() {
      //   tkTaskAssignService
      //     .findAll({taskId: this.parentTaskId})
      //     .then(response => {
      //       let receiverUserDeptRoleIds = h.collect(
      //         response.data,
      //         item => item.receiverUserDeptRoleId
      //       );
      //       userDeptRoleViewService
      //         .findAllByIdIn(receiverUserDeptRoleIds)
      //         .then(response => (this.receivers = response.data));
      //     });
      // },

      removeDocRelation(docRelation) {
        this.docRelations.splice(this.docRelations.indexOf(docRelation), 1);
        this.docIds.splice(this.docIds.indexOf(docRelation.id), 1);
      },

      removeCoordinator(coordinator) {
        this.coordinators.splice(this.coordinators.indexOf(coordinator), 1);
      },

      initForm() {
        if (this.taskType === constants.TASK_TASK_TYPE.DANGKI) {
          this.form.receiverUserDeptRole = this.$store.getters.userDeptRole;
        } else if (this.taskType === constants.TASK_TASK_TYPE.GIAOVIEC) {
          this.form.assignerUserDeptRole = this.$store.getters.userDeptRole;
        }
      },

      cancel() {
        this.$emit("closeDialog");
      },

      save() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message({message: "Có lỗi nhập liệu", type: "error"});
            return;
          }
          let submitForm = {
            taskTitle: this.form.taskTitle,
            taskDetail: this.form.taskDetail,
            deadline: this.form.deadline,
            startDate: this.form.startDate,
            manday: this.form.manday,
            parentId: this.parentTaskId,
            priorityId: this.form.priority ? this.form.priority.id : null,
            receiverUserDeptRoleId: this.form.receiverUserDeptRole
              ? this.form.receiverUserDeptRole.id
              : null,
            assignerUserDeptRoleId: this.form.assignerUserDeptRole
              ? this.form.assignerUserDeptRole.id
              : null,
            delegatorId: this.form.delegator ? this.form.delegator.id : null,
            coordinatorForms: h.collect(this.coordinators, coordinator => {
              return {coordinatorUserDeptRoleId: coordinator.id};
            }),
            docRelationForms: h.collect(this.docRelations, docRelation => {
              return {
                docId: docRelation.docId,
                docType: docRelation.docType,
                quote: docRelation.quote,
                docCode: docRelation.docCode,
                docDate: docRelation.docDate
              };
            }),
            attachmentIds: h.collect(
              this.vbAttachments,
              vbAttachment => vbAttachment.id
            )
          };
          this.isProcessing = true;
          tkTaskService
            .insert(submitForm)
            .then(response => {
              this.isProcessing = false;
              this.$message({
                message: "Tạo công việc mới thành công",
                type: "success"
              });
              this.$emit("success", {tkTask: response.data});
            })
            .catch(error => {
              this.isProcessing = false;
              return this.commonHandleRequestError(error);
            });
        });
      },

      loadAssigners() {
        userDeptRoleViewService
          .findAllAssignersForTask({
            sort: ["deptPath", "positionOrder", "fullName"]
          })
          .then(response => (this.assigners = response.data));
      },

      loadReceivers() {
        let delegatorId =
          this.form.checkTaskDelegate && this.form.delegator
            ? this.form.delegator.id
            : null;
        userDeptRoleViewService
          .findAllReceiversForTask(
            this.parentTaskId,
            null,
            {
              sort: ["deptName", "positionOrder", "fullName"]
            },
            delegatorId
          )
          .then(response => (this.receivers = response.data));
      },

      loadAllDelegatorByCurrentUser() {
        userDeptRoleViewService.findAllDelegatorByToUser().then(response => {
          this.listDelegator = response.data;
          if (this.listDelegator && this.listDelegator.length > 0) {
            this.showDelegateRow = true;
          } else {
            this.showListDelegator = false;
            this.showDelegateRow = false;
          }
        });
      },

      removeAttachment(vbAttachmentIndex) {
        this.vbAttachments.splice(vbAttachmentIndex, 1);
        this.attachmentFiles.splice(vbAttachmentIndex, 1);
      },

      uploadAttachmentSuccess(vbAttachment) {
        this.vbAttachments.push(vbAttachment);
      },

      uploadAttachmentAdditionalData() {
        return {
          objectType: constants.ATTACHMENT_OBJECT_TYPE.TASK,
          note: ""
        };
      },

      loadCategories() {
        categoryViewService
          .findAll(
            {groupCode: constants.CATEGORY_GROUP_CODE.TASK_PRIORITY},
            {sort: "order,asc", page: 0, size: 1000}
          )
          .then(
            response =>
              (this.priorities = utils.filterCategoryData(
                response.data,
                constants.CATEGORY.STATUS.ACTIVE
              ))
          );
      },

      closeAddCoordinatorsDialog() {
        this.isOpenAddCoordinatorsDialog = false;
      },

      addCoordinators(event) {
        h.each(event.userDeptRoleViews, userDeptRoleView => {
          if (
            h.find(
              this.coordinators,
              coordinator => coordinator.id === userDeptRoleView.id
            )
          )
            return;
          this.coordinators.push(userDeptRoleView);
        });
        this.isOpenAddCoordinatorsDialog = false;
      },

      addDocRelations(event) {
        let docType = event.docType;
        h.each(event.docs, doc => {
          /**
           * neu van ban da dc add roi thi khong can add nua;
           */

          if (docType === constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN) {
            if (
              h.find(
                this.docRelations,
                docRelation =>
                  docRelation.docId === doc.vbIncomingDocUserViewKey.id
              )
            )
              return;
            this.docIds.push(doc.vbIncomingDocUserViewKey.id);
            this.docRelations.push({
              docId: doc.vbIncomingDocUserViewKey.id,
              docType: constants.TASK_DOC_RELATION.VB_DEN,
              quote: doc.quote,
              docCode: doc.docCode,
              docDate: doc.docDate
            });
          } else {
            /**
             * neu van ban da dc add roi thi khong can add nua;
             */
            if (
              h.find(
                this.docRelations,
                docRelation =>
                  docRelation.docId === doc.vbOutgoingDocUserViewKey.id
              )
            )
              return;
            this.docIds.push(doc.vbOutgoingDocUserViewKey.id);
            this.docRelations.push({
              docId: doc.vbOutgoingDocUserViewKey.id,
              docType: constants.TASK_DOC_RELATION.VB_DI,
              quote: doc.quote,
              docCode: doc.docCode,
              docDate: doc.docDate
            });
          }
        });
        this.isOpenAddDocDialog = false;
      },

      closeAddDocDialog() {
        this.isOpenAddDocDialog = false;
      },

      customLabelPriority(option) {
        return option.categoryName;
      },

      customLabelSelectPeople(option) {
        return `${option.fullName} (${option.positionName} - ${option.deptName})`;
      },

      getPriorityClass(name) {
        switch (name) {
          case "Cao":
            return "lv1";
          case "Trung bình":
            return "lv2";
          case "Thấp":
            return "lv3";
          default:
            return "lv3";
        }
      }
    }
  };
</script>

<style scoped>
  .avatar_fake {
    color: #39ca74;
    background-color: rgba(57, 202, 116, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/views/job/create-job/dialog-create.vue